import { Avatar, Button, Col, Form, Input, Modal, Row } from 'antd';
import React, { FunctionComponent, useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export type ConfirmResult = 'confirm' | 'cancel';

export interface ConfirmDialogProps {
  visible: boolean;
  validateString: string;
  description: string;
  subDescription?: string;
  onClose: (value: ConfirmResult) => void;
}

export const ConfirmDialog: FunctionComponent<ConfirmDialogProps> = ({
  visible,
  validateString,
  description,
  subDescription,
  onClose,
}) => {
  const [inputString, setInputString] = useState('');
  return (
    <Modal
      visible={visible}
      onOk={() => {
        setInputString('');
        onClose('confirm');
      }}
      onCancel={() => {
        setInputString('');
        onClose('cancel');
      }}
      centered
      footer={[
        <Button
          disabled={validateString !== inputString}
          key="submit"
          type="primary"
          onClick={() => {
            setInputString('');
            onClose('confirm');
          }}
        >
          Confirm
        </Button>,
      ]}
    >
      <Row justify="center" gutter={[0, 20]}>
        <Col span={24}>
          <Row justify="center">
            <Avatar
              size={56}
              style={{ backgroundColor: '#ffa629' }}
              icon={<FontAwesomeIcon icon={['far', 'exclamation-triangle']} />}
            />
          </Row>
        </Col>
        <Col span={24}>
          <Row justify="center">
            <div
              style={{
                fontWeight: 'bolder',
                fontSize: 18,
                color: '#000',
                textAlign: 'center',
              }}
              dangerouslySetInnerHTML={{
                __html: description,
              }}
            ></div>
          </Row>
        </Col>
        <Col span={24}>
          <Row justify="center">
            <div style={{ fontSize: 14, color: '#000', textAlign: 'center' }}>
              {subDescription ? (
                <span>{subDescription}</span>
              ) : (
                <span>
                  Type “{validateString}” into field below to confirm.
                </span>
              )}
            </div>
          </Row>
        </Col>
        <Col span={24}>
          <Form>
            <Input
              value={inputString}
              onChange={e => setInputString(e.target.value)}
              placeholder={`Type "${validateString}"`}
            />
          </Form>
        </Col>
      </Row>
    </Modal>
  );
};
